import React, { useEffect } from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import { capitalizeFirstLetter } from "../../../utils";
import * as FleetCoachAppReleasesActions from "../../../store/actions/FleetCoachAppReleases";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const allActions = ["edit", "launch", "download_apk"];

const ActionBarAppReleasesList = ({
  handleBlur,
  permissions,
  top,
  right,
  activeAppRelease,
  handleRowClick,

  // stateProps
  allMenuActions,

  // dispatch props
  getApkDownloadUrl,
}) => {
  const handleActionClick = (action, activeAppRelease) => {
    switch (action) {
      case "edit":
        handleRowClick("Edit", activeAppRelease);
        break;
      case "launch":
        handleRowClick("Launch", activeAppRelease);
        break;
      case "download_apk":
        getApkDownloadUrl(activeAppRelease["id"]).then((download_url) => {
          download_url && window.open(download_url);
        });
        break;
      default:
        break;
    }
    handleBlur();
  };

  const isActionAllowed = (action) => {
    switch (action) {
      case "edit":
        return allMenuActions[permissions.UPDATE];
      default:
        return true;
    }
  };

  const getAllActions = () => {
    if (activeAppRelease["state"] === "STABLE") {
      return allActions.filter((val) => val !== "launch");
    }
    return allActions;
  };

  useEffect(() => {
    if (right && top) {
      document.getElementById("actionsBox").style.right = right + "px";
      document.getElementById("actionsBox").style.top = top + "px";
      document.getElementById("layer-mask").style.opacity = 1;
    }
  }, [right, top]);

  return (
    <LayerMask id="layer-mask" onClick={handleBlur}>
      {" "}
      <AppReleasesActions onClick={(e) => e.stopPropagation()} id="actionsBox">
        {" "}
        {getAllActions().map((action, index) => {
          return (
            isActionAllowed(action) && (
              <li
                onClick={() => handleActionClick(action, activeAppRelease)}
                key={index}
              >
                {" "}
                {capitalizeFirstLetter(action.split("_").join(" "))}{" "}
              </li>
            )
          );
        })}{" "}
      </AppReleasesActions>
    </LayerMask>
  );
};

const LayerMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  opacity: 0;
`;

const AppReleasesActions = styled.ul`
  list-style-type: none;
  position: absolute;
  background: #fff;
  border: 0.5px solid ${variables.grey100};
  padding: unset;
  max-width: 150px;
  border-radius: 8px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  li {
    padding: 8px;
    cursor: pointer;
    &:not(:last-child) {
      border-bottom: 1px solid ${variables.grey100};
    }
  }
`;

function mapDispatchToProps(dispatch) {
  return {
    getApkDownloadUrl: bindActionCreators(
      FleetCoachAppReleasesActions.getApkDownloadUrl,
      dispatch
    ),
  };
}

function mapStateToProps(state) {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActionBarAppReleasesList);
